<template>
  <f7-page name="etc" no-swipeback-tmp>
    <f7-navbar>
      <f7-nav-left>
        <!-- <f7-link back><img src="/static/images/common/header/arrow_l_white.svg"></f7-link> -->
      </f7-nav-left>
      <f7-nav-title>ポイント運用</f7-nav-title>
      <f7-nav-right>
        <f7-link href="/faq_list/"><img :src="addAssetsPublicPath('static/images/common/header/icon_question.svg')"></f7-link>
        <span class="space4closeicon"/>
        <!-- <f7-link ><img src="/static/images/common/header/icon_close.svg"></f7-link> -->
      </f7-nav-right>
    </f7-navbar>
    <f7-block class="page_title">
      <p>その他</p>
    </f7-block>
    <f7-block class="items">
      <f7-list>
        <f7-list-item v-for="item in items" v-bind:key="item.title" v-bind:link="item.href" :animate="false" >
          <img class="icon" alt="" v-bind:src="item.icon"><span class="title" v-html="item.title"></span>
        </f7-list-item>
      </f7-list>
    </f7-block>
  </f7-page>
</template>

<script>
  import { addAssetsPublicPath } from '@/utils/env.js';

  export default {
    data() {
      let rewrite = this.initRouter();
      return {
        items:[
          {
            icon:addAssetsPublicPath('static/images/common/icon_loupe.svg'),
            title:'サービス紹介',
            href:'/how_to_use/',
          },
          {
            icon:addAssetsPublicPath('static/images/common/icon_bell.svg'),
            title:'お知らせ',
            href:'/notice/',
          },
          {
            icon:addAssetsPublicPath('static/images/common/icon_faq.svg'),
            title:'よくある質問',
            href:'/faq_list/',
          },
          {
            icon:addAssetsPublicPath('static/images/common/icon_checklist.svg'),
            title:'利用規約',
            href:'/terms/',
 	        },
          {
            icon:addAssetsPublicPath('static/images/common/icon_privacy.svg'),
            title:'プライバシーポリシー',
            href:'/privacypolicy/',
 	        },
          // {
          //   icon:'/static/images/common/icon_checkhand.svg',
          //   title:'投資についてもっと学ぶ<span class="exlink">（外部サイト）</span>',
          //   href:'paypay://embed?url=https://www.stg-pubelb.onetapbuy.jp/',
          // },
          // {
          //   icon:'/static/images/common/icon_checkhand.svg',
          //   title:'One Tap BUY 口座開設<span class="exlink">（外部サイト）</span>',
          //   href:'paypay://embed?url=https://www.stg-pubelb.onetapbuy.jp/clientreqs/',
          // }
        ]
      }
    },
    methods: {
      initRouter(){
        // example: redirect to static page
        var toParam = g.getParam('to');
        console.log('url to : ' + toParam)
        if(toParam != null) {
          switch(toParam) {
            case 'services':
              setTimeout(()=> {
                this.$f7router.navigate({
                  name: 'services',
                  params: { noheader: 1 },
                },{animate:false,});
              })
              return true;
            case 'privacypolicy':
              setTimeout(()=> {
                this.$f7router.navigate({
                  name: 'privacypolicy',
                  params: { noheader: 1 },
                },{animate:false,});
              })
              return true;
            case 'terms':
              setTimeout(()=> {
                console.log("t00000o");
                this.$f7router.navigate({
                  name: 'terms',
                  params: { noheader: 1 },
                },{animate:false,});
              })
              return true;
            case 'faq_list':
              setTimeout(()=> {
                this.$f7router.navigate({
                name: 'faq_list',
                params: { noheader: 1 },
                },{animate:false,});
              })
              return true;
            case 'sessiontimeout':
              setTimeout(()=> {
               this.$root.error({'_ekey': 'timeout'}, 0, this.$f7router);
              })
              return true;
            case 'maintenance':
              setTimeout(()=> {
                this.$f7router.navigate({
                  name: 'error',
                  params: { id: 4 },
                });
              })
              return true;
          }
        }
        return false;
      },
      init(){
      },
      addAssetsPublicPath,
    },
    mounted() {
      this.init();
      this.$f7ready((f7) => {
        // Call F7 APIs here
      });
    }
  }
</script>
